import { Route, Routes } from 'react-router-dom';
import Home from './routes/Home';
import Course from './routes/Course';
import UnitStart from './routes/UnitStart';
import Quiz from './routes/Quiz';
import Results from './routes/Results';
import Fluency from './routes/Fluency';

export default function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/c/:courseSlug" element={<Course />} />
        <Route path="/q/:unitId" element={<UnitStart />} />
        <Route path="/q/:unitId/play" element={<Quiz />} />
        <Route path="/q/:unitId/results" element={<Results />} />
        <Route path="/f/:courseSlug" element={<Fluency />} />
      </Routes>
    </div>
  );
}
